"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClothesDye = void 0;
const Class_1 = require("./Class");
const ClothesColor_1 = require("./ClothesColor");
const definables_1 = require("definables");
class ClothesDye extends definables_1.Definable {
    constructor(options) {
        super(options.id);
        this._classIDs = options.definition.classIDs;
        this._isDefault = options.definition.isDefault;
        this._primaryClothesColorID = options.definition.primaryClothesColorID;
        this._secondaryClothesColorID = options.definition.secondaryClothesColorID;
    }
    get classIDs() {
        return this._classIDs;
    }
    get classes() {
        return this._classIDs.map((classID) => (0, definables_1.getDefinable)(Class_1.Class, classID));
    }
    get isDefault() {
        var _a;
        return (_a = this._isDefault) !== null && _a !== void 0 ? _a : false;
    }
    get primaryClothesColor() {
        return (0, definables_1.getDefinable)(ClothesColor_1.ClothesColor, this._primaryClothesColorID);
    }
    get secondaryClothesColor() {
        return (0, definables_1.getDefinable)(ClothesColor_1.ClothesColor, this._secondaryClothesColorID);
    }
}
exports.ClothesDye = ClothesDye;
